import * as Yup from "yup";

export const ResetPasswordSchema = Yup.object().shape({
  code: Yup.string()
    .required("Please enter your confirmation code")
    .matches(/^[0-9]+$/, "Must be only digits")
    .test("len", "Must be exactly 6 digits", (val) => val?.length === 6),
  newPassword: Yup.string()
    .required("Please enter your password")
    .min(8, "Password must be at least 8 characters long")
    .matches(/^(?=.*\d)/, "At least 1 numeric digit is required")
    .matches(/^(?=.*[A-Z])/, "At least 1 uppercase character is required")
    .matches(/^(?=.*[a-z])/, "At least 1 lowercase character is required")
    .matches(/^(?=.*[@$!%*?&])/, "At least 1 special character is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Please confirm your password"),
});
